// eslint-disable-next-line @typescript-eslint/ban-types
export function extractProperty<T extends object, K extends keyof T>(
  property: K
) {
  return function extractFrom(source: T): T[K] {
    return source[property];
  };
}
